'use client'

import { cn } from '@/utilities/cn'
import React, { useRef } from 'react'

import type { MediaProps as MediaProps } from '../types'
import getSiteUrl from '@/lib/common/getSiteUrl'
import { createClientLogger } from '@/lib/logger/client'

const log = createClientLogger('VideoMedia')

export const VideoMedia: React.FC<MediaProps> = (props) => {
  const { onClick, resource, videoClassName } = props

  const videoRef = useRef<HTMLVideoElement>(null)

  log.debug({ resource }, 'Rendering video')
  if (resource && typeof resource === 'object') {
    const { filename } = resource

    return (
      <video
        autoPlay
        className={cn(videoClassName)}
        controls={false}
        loop
        muted
        onClick={onClick}
        playsInline
        ref={videoRef}
      >
        <source src={`${getSiteUrl()}/media/${filename}`} />
      </video>
    )
  }

  return null
}
